import Icon from '@Shared/Icon';
import Markdown from '@Shared/Markdown';
import { IArticle } from '@src/interfaces';
import moment from 'moment';
import React from 'react';

interface Props {
  article: IArticle
}

const Article: React.FC<Props> = (props) => {

  const demote = (markdown: string | null | undefined, levels: number): string => {
    return (markdown ?? '').replace(
      /^([#]+)/g, // first line
      '$1' + ('#####'.substring(0, levels))
    ).replace(
      /[\n]([#]+)/g, // every additional line beginning with #
      '\n$1' + ('#####'.substring(0, levels))
    );
  }

  return (
    <article className="blog blog-entry">
      <div className="createdateonly date-top">
        <Icon name='calendar-alt' right={8} />
        {moment.unix(props.article.created.epoch).format("MMMM Do YYYY, h:mm a")}
      </div>
      <Markdown id={'article-' + props.article.id} className='blog-text'>
        {demote(props.article.markdown ?? '', 1)}
      </Markdown>
    </article>
  );
}

export default Article;
